import React, { useEffect, useState } from "react";

/* Images */
import imagesInjectionMoulds from '../../images/injectionMoulds';
import householdProducts from '../../images/householdProducts';
import technicalProducts from '../../images/technicalProducts';
import specialApplications from '../../images/specialApplications';
import medicalDevices from '../../images/medicalDevices';
import sales from '../../images/sales';

/* Styles */
import "./dialog.css";
export default function Dialog({ open, onClose, title, typeImages }) {
    const [images, setImages] = useState([]);

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };

        if (open) {
            document.addEventListener("keydown", handleEsc);
            document.body.style.overflow = "hidden";
        }

        return () => {
            document.removeEventListener("keydown", handleEsc);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    useEffect(() => {
        const properItems = checkProperImages();

        setImages(properItems);
    }, [typeImages]);

    useEffect(() => {
        console.log(images);
    }, [images]);

    const checkProperImages = () => {
        let data = [];

        switch(typeImages) {
            case 'rigidPackage':
                data = imagesInjectionMoulds;
                break;

            case 'householdProducts':
                data = householdProducts;
                break;

            case 'technicalProducts':
                data = technicalProducts;
                break;

            case 'specialApplications':
                data = specialApplications;
                break;

            case 'medicalDevices':
                data = medicalDevices;
                break;

            case 'sales':
                data = sales;
                break;

            default:
                return;
        }

        return data;
    }

    if (!open) return null;

    return (
        <div className="dialog-backdrop" onClick={onClose}>
            <div
                className="dialog"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <button
                    className="dialog-close"
                    aria-label="Close dialog"
                    onClick={onClose}
                >
                    ✕
                </button>

                {title && <h2 className="dialog-title">{title}</h2>}

                <div className="dialog-content">
                    {
                        images && images.length
                            ? images.map((src, i) => (
                                <div className="image-holder">
                                    <img key={i} src={src} alt="" />
                                </div>
                            ))
                            : null
                    }
                </div>
            </div>
        </div>
    );
}